export default __webpack_public_path__ + "static/media/bannerMb.bcd75aff.png";